module.exports = __webpack_public_path__ + "img/cabCorte2.fc149341.jpg";